import _ from 'lodash';

export default class LedgersCtrl {
  constructor(
    $state,
    $stateParams,
    LedgerCategoryCollection,
    LedgerCategoryOrderCollection,
    LedgerCollection,
    AddOnCollection,
    CurrencyCollection,
    User,
    ClientSettings,
    $mdDialog,
  ) {
    this.$state = $state;
    this.LedgerCategoryCollection = LedgerCategoryCollection;
    this.LedgerCategoryOrderCollection = LedgerCategoryOrderCollection;
    this.LedgerCollection = LedgerCollection;
    this.AddOnCollection = AddOnCollection;
    this.$mdDialog = $mdDialog;
    this.editLedger = this.editLedger.bind(this);
    this.deleteLedger = this.deleteLedger.bind(this);
    this.reorderLedger = this.reorderLedger.bind(this);
    this.editAddon = this.editAddon.bind(this);
    this.deleteAddon = this.deleteAddon.bind(this);
    this.reorderAddon = this.reorderAddon.bind(this);
    this.setLedgersByCategory = this.setLedgersByCategory.bind(this);
    this.sortLedgerCategory = this.sortLedgerCategory.bind(this);
    this.editAccount = $stateParams.editAccount;
    this.clientId = User.getClientId();
    this.settings = new ClientSettings(this.clientId);
  }

  $onInit() {
    this.showActiveLedgers = true;
    this.showAccountLedgers = false;
    this.sortByAlpha = false;
    this.ledgerCategoryCollection = new this.LedgerCategoryCollection();
    this.ledgerCategoryOrderCollection = new this.LedgerCategoryOrderCollection(
      this.ledgerCollectionId,
    );
    this.ledgerCollection = new this.LedgerCollection(this.ledgerCollectionId);
    this.addonCollection = new this.AddOnCollection(this.ledgerCollectionId);
    this.ledgersByCategory = {};

    this.ledgerCollection.$onSet(this.setLedgersByCategory);

    if (!this.selectedTab) {
      this.setActiveTab('ledgers');
    }

    if (this.editAccount) {
      if (this.selectedTab === 'ledgers') {
        this.editLedger();
      } else {
        this.editAddon();
      }
    }
  }

  setActiveTab(tab) {
    this.selectedTab = tab;
    this.$state.transitionTo('bench.ledgers', { selectedTab: tab }, { notify: false });
  }

  setLedgersByCategory() {
    this.ledgersByCategory = this.ledgerCollection.$getLedgersByCategory();
  }

  onSaveLedger() {
    this.ledgerCollection.$fetch().then(this.setLedgersByCategory);
  }

  editLedger(ledger) {
    const ledgerId = this.getAccountId(ledger);
    const onSave = () => this.ledgerCollection.$fetch().then(this.setLedgersByCategory);

    const ledgerTemplate = `
        <md-dialog aria-label='Edit Ledger Dialog' class='edit-dialog'>
          <edit-ledger client-id="${this.clientId}" ledger-id="${ledgerId}"></edit-ledger>
        </md-dialog>
      `;

    return this.$state
      .go('bench.ledgers', { editAccount: ledgerId }, { notify: false })
      .then(() => this.openEditModal(ledgerId, ledgerTemplate, onSave));
  }

  editAddon(addon) {
    const addonId = this.getAccountId(addon);

    const onSave = () => this.addonCollection.$fetch();
    const addOnTemplate = `
      <md-dialog aria-label="Edit Ledger Dialog" class="edit-dialog">
        <bl-edit-addon
          addon-id="'${addonId}'">
        </bl-edit-addon>
      </md-dialog>
    `;

    return this.$state
      .go('bench.ledgers', { editAccount: addonId }, { notify: false })
      .then(() => this.openEditModal(addonId, addOnTemplate, onSave));
  }

  openEditModal(accountId, template, onSave) {
    return this.$mdDialog
      .show({
        clickOutsideToClose: true,
        focusOnOpen: true,
        template,
      })
      .then(onSave)
      .finally(() => {
        this.editAccount = null;
        this.$state.go('bench.ledgers', { editAccount: null }, { notify: false });
      });
  }

  getAccountId(account) {
    let accountId = account ? account.id : '';

    if (this.editAccount) {
      accountId = this.editAccount;
    }
    return accountId;
  }

  showDeleteLedgerWarning(message) {
    const defaultMessage =
      'This ledger cannot be deleted because it has transactions in it. ' +
      'If you would like to delete this ledger, ' +
      'transfer all of its transactions to a different ledger first.';

    const alert = this.$mdDialog
      .alert()
      .textContent(message || defaultMessage)
      .ok('Got it!');

    this.$mdDialog.show(alert);
  }

  deleteLedger(e, ledger) {
    const confirm = this.$mdDialog
      .confirm()
      .textContent(
        `Are you sure you want to delete this ledger ("${ledger.name}") ? ` +
          'This action is irreversible. ' +
          '(Make sure all statements are reassigned to a different ledger)',
      )
      .targetEvent(e)
      .openFrom('[ng-app]')
      .closeTo('[ng-app]')
      .ok('Confirm')
      .cancel('Cancel');

    return this.$mdDialog.show(confirm).then(() => {
      ledger.$delete().catch(err => {
        if (err.status === 400) {
          this.showDeleteLedgerWarning();
        }

        if (err.messages && err.messages.length) {
          this.showDeleteLedgerWarning(err.messages[0]);
        }
      });
    });
  }

  deleteAddon(e, addon) {
    const notifyDeleteFailure = () => {
      const deleteFailure = this.$mdDialog
        .alert()
        .content('There was an error deleting the add on. Please try again later.')
        .ok('Dismiss');

      return this.$mdDialog.show(deleteFailure);
    };

    const deleteAddon = () => addon.$delete().catch(notifyDeleteFailure);

    const confirmAndDelete = () => {
      const entryText = addon.entryCount === 1 ? 'Entry' : 'Entries';
      const textContent =
        addon.entryCount === 0
          ? `Are you sure you want to delete this ledger ("${addon.name}") ? ` +
            'This action is irreversible.'
          : `This ("${addon.name}") Add-On is linked to ${addon.entryCount} Journal ${entryText}. ` +
            'Deleting the Add-On will remove these links and cannot be reversed. Do you wish to continue?';

      const confirm = this.$mdDialog
        .confirm()
        .textContent(textContent)
        .targetEvent(e)
        .openFrom('[ng-app]')
        .closeTo('[ng-app]')
        .ok('Confirm')
        .cancel('Cancel');
      return this.$mdDialog.show(confirm).then(deleteAddon);
    };

    const notifyFetchFailure = () => {
      const fetchFailure = this.$mdDialog
        .alert()
        .textContent(
          `There was an error fetching journal entries associated to the add on ("${addon.name}"). Please try again later.`,
        )
        .ok('Dismiss');
      return this.$mdDialog.show(fetchFailure);
    };

    return addon.$fetchJECount().then(confirmAndDelete, notifyFetchFailure);
  }

  reorderLedger(ledgerId, nextLedgerId, isLast) {
    const ledger = this.ledgerCollection.$findById(ledgerId);

    ledger.$reorderTo(nextLedgerId, isLast).catch(e => {
      const message =
        _.get(e, 'data.messages[0].message') || 'There was an problem reordering this ledger.';

      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(3000));
    });
  }

  getLedgerCount() {
    if (this.hideLedgers) {
      return this.ledgerCollection.data.filter(ledger => ledger.$isAccount()).length;
    }

    return this.ledgerCollection.$length();
  }

  reorderAddon(addonId, nextAddonId) {
    this.addonCollection.$reorder(addonId, nextAddonId).catch(e => {
      const message =
        _.get(e, 'data.messages[0].message') || 'There was an problem reordering this addon.';

      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(3000));
    });
  }

  sortLedgerCategory(categoryId, sortByAlpha) {
    let model = this.ledgerCategoryOrderCollection.$findById(categoryId);

    if (!model) {
      model = this.ledgerCategoryOrderCollection.$add({
        categoryId,
        clientId: this.ledgerCollectionId,
      });
    }

    let request;

    if (sortByAlpha) {
      request = model.$orderByAlpha();
    } else {
      request = model.$orderManual();
    }

    request.catch(() => {
      const message = 'There was an error saving the sorting order of your ledger category.';
      this.$mdToast.show(this.$mdToast.simple().textContent(message).hideDelay(3000));
    });
  }
}
